import { DirectoriesService } from './../../../../shared/services/directories.service';
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ResellerRegisterModel } from '../../../models/resellerRegisterModel';
import { PurchaseService } from '../../../services/purchase.service';
import { AccountService } from '../../../../../management/account/services/account.service';
import { AuthService } from '../../../../../../core/auth/_services/auth.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { ProfileDocumentModel } from '../../../../../management/account/models/profile/ProfileDocumentModel';
import { ResellerUpdateModel } from '../../../../../management/account/models/profile/resellerUpdateModel';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-seller-info-form-comp',
  templateUrl: './seller-info-form-comp.component.html',
  styleUrls: ['./seller-info-form-comp.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerInfoFormCompComponent implements OnInit {
  provinces: any = [];
  directories: any = [];
  @Input('back') back: boolean = false;
  @Input('loading') loading: boolean = false;
  @Input('forward') forward: boolean = false;
  @Input('nationalCardUrl') nationalCardUrl: any = null;
  @Input('registrationForm') registrationForm: FormGroup;

  store: any;

  constructor(private directoriesService: DirectoriesService,
    private cdr: ChangeDetectorRef,
    private purchaseService: PurchaseService,
    private accountService: AccountService,
    private auth: AuthService,
  ) { }

  ngOnInit() {
    //گرفتن لیست استان ها
    this.provinces = this.directoriesService.getProvinces();
  }
  isControlHasError(controlName: string, validationType: string, form: string): boolean {
    const control = this.registrationForm.get(form).get(controlName);
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType);
    return result;

  }

  provinceChange(parentId) {
    this.registrationForm.get('sellerInfoForm').get('directoryId').setValue(null);
    this.directories = this.directoriesService.getDirectoriesByParentId(parentId);
  }

  onSelect(files) {
    if (!files[0]) return;
    if (files[0].type != 'image/png' && files[0].type != 'image/jpg' && files[0].type != 'image/jpeg') {
      this.showAlert("فقط مجاز به آپلود تصویر می باشید", 'danger');
      return;
    }

    if (files[0].size > 2000000) {
      this.showAlert("حجم فایل آپلود شده باید کمتر از 2 مگابایت باشد", 'danger');
      return;
    }


    this.files[0] = files[0];
    this.selectedFileName = this.files[0].name;
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.nationalCardUrl = reader.result;
      this.message = null;
      this.cdr.markForCheck();
    }
  }

  files: File[] = [];
  selectedFileName: string;
  nationalFileName: string = "";

  message: string;
  messageType: string;
  uploadError: string = null;
  statusReport: string = null;
  profileDocument: ProfileDocumentModel = new ProfileDocumentModel();
  isFileDeleted: boolean = false;
  saveResellerDocumentFaild = false;

  showAlert(message: string, type: string) {
    this.message = message;
    this.messageType = type;
    this.cdr.markForCheck();
  }



  @Output('backClick') backClick = new EventEmitter();
  @Output('forwardClick') forwardClick = new EventEmitter();

  backEvent() {
    this.backClick.emit();
  }

  forwardEvent() {
    const controls = this.registrationForm.controls['sellerInfoForm']['controls'];
    /** check form */

    if (this.registrationForm.get('sellerInfoForm').invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }

    //first Upload The National Card ProfileAttachemntDocumentType
    if (this.nationalCardUrl == null) {
      this.uploadError = "لطفا کپی کارت ملی خود را انتخاب نمائید";
      return;
    }

    if (this.invalidEmail == true) {
      this.uploadError = "ایمیل وارد شده معتبر نمی باشد";
      return;
    }

    var data = new FormData();
    data.append('file', this.files[0]);
    data.append('userDocumentType', this.profileDocument.userDocumentType.toString());
    data.append('description', this.profileDocument.description);
    data.append('phoneNumber', this.profileDocument.phoneNumber);
    data.append('isFileDeleted', String(this.isFileDeleted));

    this.accountService.saveResellerDocument(data).subscribe((res: any) => {
      this.saveResellerDocumentFaild = false;

      var model = new ResellerUpdateModel();
      model.address = this.registrationForm.get('sellerInfoForm').get('address').value;
      model.email = this.registrationForm.get('sellerInfoForm').get('email').value;
      model.resellerType = this.registrationForm.get('sellerInfoForm').get('resellerType').value;
      model.shop = this.registrationForm.get('sellerInfoForm').get('shopName').value;
      model.url = this.registrationForm.get('sellerInfoForm').get('url').value;
      model.zipCode = this.registrationForm.get('sellerInfoForm').get('zipCode').value.FaToEnDigits();
      model.directoryId = this.registrationForm.get('sellerInfoForm').get('directoryId').value;
      this.loading = true;
      this.accountService.updateResellerInfo(model).subscribe((res: any) => {
        this.loading = false;
        this.cdr.markForCheck();
        this.forwardClick.emit();
      });
    }, (err) => {
      if (err.error)
        this.saveResellerDocumentFaild = true;
    })


  }

  deleteNational() {

    this.nationalCardUrl = null;
    this.files[0] = null;
    this.selectedFileName = null;
  }



  invalidEmail: boolean = false;
  existEmail() {
    this.accountService.isValidEmail(this.registrationForm.get('sellerInfoForm').get('email').value).subscribe((res: boolean) => {
      if (!res) {
        this.showAlert("ایمیل وارد شده قبلا در سیستم ثبت شده است", 'danger');
        this.invalidEmail = true;
      }
      else {
        this.message = null;
        this.invalidEmail = false;
      }
      this.cdr.markForCheck();
    });
  }

}
